/** Относительная яркость sRGB по WCAG 2.x и отношение контраста — для замера «боец против фона». */
const channel = (value: number): number => {
  const c = value / 255;
  return c <= 0.04045 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
};

export const luminance = (r: number, g: number, b: number): number =>
  0.2126 * channel(r) + 0.7152 * channel(g) + 0.0722 * channel(b);

export const contrastRatio = (a: number, b: number): number => (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);

/**
 * Контраст бойца к окружению в готовом кадре: средняя яркость его пикселей (mask = side + 1) против средней
 * яркости соседних не-бойцовских пикселей в его рамке, расширенной на margin.
 */
export function maskContrast(image: ImageData, mask: Uint8Array, side: number, margin = 10): number {
  const { width, height, data } = image;
  let left = width;
  let right = -1;
  let top = height;
  let bottom = -1;
  for (let index = 0; index < mask.length; index++) {
    if (mask[index] !== side + 1) continue;
    const x = index % width;
    const y = (index - x) / width;
    left = Math.min(left, x);
    right = Math.max(right, x);
    top = Math.min(top, y);
    bottom = Math.max(bottom, y);
  }
  if (right < 0) return 0;
  let fighter = 0;
  let fighterCount = 0;
  let around = 0;
  let aroundCount = 0;
  for (let y = Math.max(0, top - margin); y <= Math.min(height - 1, bottom + margin); y++) {
    for (let x = Math.max(0, left - margin); x <= Math.min(width - 1, right + margin); x++) {
      const index = y * width + x;
      const offset = index * 4;
      const value = luminance(data[offset] ?? 0, data[offset + 1] ?? 0, data[offset + 2] ?? 0);
      if (mask[index] === side + 1) {
        fighter += value;
        fighterCount++;
      } else if (mask[index] === 0) {
        around += value;
        aroundCount++;
      }
    }
  }
  return fighterCount === 0 || aroundCount === 0 ? 0 : contrastRatio(fighter / fighterCount, around / aroundCount);
}
